<template>
  <div class="home">
    <HistoryBlock />
    <ArticlesBlock
      @openArticle="(id) => $emit('openArticle', id)"
      articletype="feed"
    />
  </div>
</template>

<script>
import ArticlesBlock from '@/components/blocks/articles/ArticlesBlock.vue';
import HistoryBlock from '@/components/blocks/history/HistoryBlock.vue';

export default {
  name: 'HomePage',
  components: {
    ArticlesBlock,
    HistoryBlock,
  },
};
</script>

<style lang="scss" scoped></style>
